import { connect } from 'react-redux';
import NotificationBanner from 'app/components/partials/notification-banner';
import {
    fetchNotificationsAction,
    updateNotificationAction
} from 'app/ducks/notifications';
import {
    selectIsActive,
    selectNotifications,
    selectShowNotification
} from 'app/selectors/notifications';

const mapStateToProps = (state) => ({
    notifications: selectNotifications(state),
    isActive: selectIsActive(state),
    showNotification: selectShowNotification(state)
});

const mapDispatchToProps = (dispatch) => ({
    fetchNotifications: () => dispatch(fetchNotificationsAction()),
    updateNotification: (notificationId) => dispatch(updateNotificationAction(notificationId))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NotificationBanner);
